import { createSlice } from '@reduxjs/toolkit';
import { getPersonExperienceListThunk } from './PersonExperience.thunk';

export const personExperienceSlice = createSlice({
  name: 'personExperience',
  initialState: {
    list: {
      items: [],
      loading: true,
    },
  },
  reducers: {
    //
  },
  extraReducers: builder => {
    // Start Person Experience lsit
    builder.addCase(getPersonExperienceListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getPersonExperienceListThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.list = { ...state.list, items: data, loading: false };
    });
    builder.addCase(getPersonExperienceListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End Person Experience list
  },
});

export const getPersonExperienceList = (state: any) =>
  state.personExperience.list;

export default personExperienceSlice.reducer;
